export default ({ glAccounts = [], allowFromAccount, requireAccount, accountOverride, toAccount }) => ({
  formData: {
    amountHasChanged: {
      value: false,
      isValid: false,
    },
    glAccountOverride: {
      value: '',
      isValid: !glAccounts.length,
    },
    taxEntryAccountId: {
      value: toAccount ? toAccount.value : '',
      isValid: !requireAccount,
    },
    fromTaxEntryAccountId: {
      value: '',
      isValid: !allowFromAccount,
    },
    adjustmentException: {
      value: accountOverride || '',
      isValid: true,
    },
    topsideFlag: {
      value: false,
      isValid: true,
    },
    fbosFlag: {
      value: false,
      isValid: true,
    },
    comment: {
      value: '',
      isValid: true,
    },
    files: [],
  },
  isCellInputDirty: false,
  isFormDirty: false,
  isFormValid: false,
  triedToSubmitForm: false,
  elementsToValidate: ['amountHasChanged'],
});
